module.exports = __webpack_public_path__ + "static/media/full-inbox-pana.d63c5b98.svg";